// src/pages/Team/ViewGodownEmployees.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import './TeamPages.css';   // reuse if you have a team styles file, else copy from ViewSubDealers.css

const ViewGodownEmployees = () => {
  const navigate = useNavigate();
  const { isSuperAdmin } = useAuth();

  const [users, setUsers]   = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const params = {};
        if (isSuperAdmin) {
          const cid = localStorage.getItem('selectedCompanyId');
          if (cid) params.companyId = cid;
        }
        const res = await api.get('/users/godown-employees', { params });
        if (res.data?.success) setUsers(res.data.data || []);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch godown employees');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [isSuperAdmin]);

  const filtered = users.filter(u => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      u.firstName?.toLowerCase().includes(s) ||
      u.lastName?.toLowerCase().includes(s) ||
      u.email?.toLowerCase().includes(s) ||
      u.assignedGodowns?.some(g => g.name?.toLowerCase().includes(s))
    );
  });

  return (
    <div className="view-subdealers-container">
      <div className="subdealers-header">
        <h4 className="subdealers-title">Godown Employees</h4>
      </div>

      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name, email, or godown..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="loading-container"><div className="spinner"></div><p>Loading...</p></div>
      ) : error ? (
        <div className="error-container"><p className="error-message">{error}</p></div>
      ) : filtered.length === 0 ? (
        <div className="empty-state"><p>No godown employees found</p></div>
      ) : (
        <div className="table-container">
          <table className="subdealers-table">
            <thead>
              <tr>
                <th>NAME</th>
                 <th>COMPANY</th>  
                <th>EMAIL</th>
                <th>PHONE</th>
                <th>EMPLOYEE CODE</th>
                <th>ASSIGNED GODOWN(S)</th>
                <th>STATUS</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u.id}>
                  <td>{u.firstName} {u.lastName}</td>
                  <td>{u.company?.name || '—'}</td> 
                  <td>{u.email || '—'}</td>
                  <td>{u.phone || '—'}</td>
                  <td>{u.employeeCode || '—'}</td>
                  <td>
                    {u.assignedGodowns?.length > 0
                      ? u.assignedGodowns.map(g => (
                          <span key={g.id} style={{
                            display: 'inline-block',
                            padding: '2px 8px',
                            margin: '2px 4px 2px 0',
                            background: '#e3f2fd',
                            color: '#1565c0',
                            borderRadius: 4,
                            fontSize: 12,
                            fontWeight: 600,
                          }}>{g.name}</span>
                        ))
                      : <span style={{ color: '#e53935', fontSize: 12 }}>None assigned</span>}
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 10px', borderRadius: 4, fontSize: 11, fontWeight: 600,
                      background: u.status === 'ACTIVE' ? '#e8f5e9' : '#ffebee',
                      color: u.status === 'ACTIVE' ? '#2e7d32' : '#c62828',
                    }}>
                      {u.status}
                    </span>
                  </td>
                  <td>
                    <button
                      className="btn-action btn-view"
                      onClick={() => navigate(`/employee/edit/${u.id}`)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ViewGodownEmployees;